import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../../../css/page-auth.css";
import { useAuth } from "../../Context/store/context.js";
import { fetchadmininfo } from "../../Redux/Actions/AdmininfoAction.js";
import DocumentTitle from '../../../documentTitle.js';
import { _get, _post } from "../../../apiClient.js";
import { _showToast } from "../../../toastHelper.js";
import { get } from "jquery";

// function to handle the refresh
export function getRootPath(url) {
  const urlParts = url.split("/");
  return `/${urlParts[1]}`;
}

export default function LogIn() {
  DocumentTitle("Reset Password");
  const [searchParams] = useSearchParams();
  const { showLoader, hideLoader, username } = useAuth();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (username && username != "") {
      setNewPassword("");
      setConfirmPassword("");
    } else {
      navigate("/login");
    }
  }, [username])


  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      resetPassword();
    }
  };

  const validate = () => {
    const errors = {};

    if (!newPassword || (newPassword && newPassword.trim() == "")) {
      errors.newPassword = "New password is required";
    }

    if (!confirmPassword || (confirmPassword && confirmPassword.trim() == "")) {
      errors.confirmPassword = "Confirm password is required";
    }


    if (newPassword && newPassword != "" && confirmPassword && confirmPassword != "" && confirmPassword != newPassword) {
      errors.confirmPassword = "Password not matching";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;

  }

  const resetPassword = async () => {
    showLoader();
    await _post("/auth/reset-password", {
      "username": username,
      "password": newPassword
    }, null, false)
      .then(() => {
        _showToast("Password reseted successfully.", "success");
        navigate("/login");
        hideLoader();
      })
      .catch((error) => {
        _showToast(error, "error");
        hideLoader();
      });
  };

  return (
    <div className="authentication-wrapper authentication-cover authentication-bg">
      <div className="authentication-inner row">
        {/* <!-- /Left Text --> */}
        <div className="d-none d-lg-flex col-lg-8 p-0">
          <div className="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center bg1 ">
            <div className="hero-banner hero-style-2 bg-image">
              <div className="banner-gallery">
                <div
                  className="thumbnail thumbnail-1"
                  data-sal-delay="500"
                  data-sal="slide-up"
                  data-sal-duration="1000"
                >
                  <img src="images/birthday_events.jpg" alt="" />
                </div>
                <div
                  className="thumbnail thumbnail-2"
                  data-sal-delay="500"
                  data-sal="slide-down"
                  data-sal-duration="1000"
                >
                  <img src="/images/cake_birthday.jpg" alt="" />
                </div>
                <div
                  className="online-support"
                  data-sal-delay="600"
                  data-sal="slide-right"
                  data-sal-duration="1000"
                >
                  <div className="inner">
                    <div className="content">
                      <span className="subtitle">INVITD</span>
                      <h4 className="title">
                        ONLINE INVITATION MAKER
                      </h4>
                    </div>
                  </div>
                </div>
                <ul className="shape-group">
                  <li
                    className="shape-2 scene"
                    data-sal-delay="1000"
                    data-sal="fade"
                    data-sal-duration="1000"
                  >
                    <img data-depth="-2" src="images/shape-12.png" alt="Shape" />
                  </li>
                  <li
                    className="shape-4 scene"
                    data-sal-delay="1000"
                    data-sal="fade"
                    data-sal-duration="1000"
                  >
                    <img data-depth="-2" src="images/shape-04.png" alt="Shape" />
                  </li>
                </ul>
              </div>
            </div>
            <img src="images/bg-image-1.png" alt="" className="platform-bg" />

            <div className="footer bg-footer-theme fcopyright  fs-13 text-center z-index">
              <div className="row">
                <div className="col-md-5">
                  ©{new Date().getFullYear()}, <a
                    href="https://ajsinnovations.in/"
                    className="text-primary"
                    target="_new"
                  >
                    AJS Innovations Pvt. Ltd.
                  </a> All Rights Reserved.
                </div>
                {/* <div className="col-md-7">
                  Software Powered By{" "}
                  <a
                    href=""
                    target="_blank"
                    className="footer-text text-primary fw-medium"
                  >
                    Edit Point India
                  </a>{" "}
                  Private Limited
                </div> */}
                {/* <div className="col-md-5">
                  Developed By{" "}
                  <a
                    href="https://ajsinnovations.in/"
                    className="text-primary"
                    target="_new"
                  >
                    AJS Innovations
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Left Text --> */}

        {/* <!-- Login --> */}
        <div className="d-flex col-12 col-lg-4 align-items-center p-sm-4 p-3">
          <div className="w-px-400 mx-auto">
            {/* <!-- Logo --> */}
            <div className="app-brand mx-6 mb-1">
              <a href="index.html">
                <span className="app-brand-logo demo">
                  <img
                    src="images/logo.png"
                    className="img-fluid my-5 auth-illustration"
                  />
                </span>
              </a>
            </div>
            {/* <!-- /Logo --> */}
            <h3 className="mb-4 fw-bold text-center">ONLINE INVITATION MAKER</h3>
            <>
              <div className="d-flex justify-content-center">
                <p className="mb-2" style={{ fontSize: "2rem" }}>
                  Reset Password
                </p>
              </div>

              <form
                id="formAuthentication"
                className="mb-3"
                onSubmit={handleSubmit}
              >

                <div className="mb-3">
                  <label className="form-label col-4 required">
                    New Password
                  </label>
                  <input
                    type="password"
                    className={`form-control ${errors.newPassword ? "is-invalid" : ""}`}
                    name="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  {errors.newPassword && (
                    <div className="text-danger ">
                      {errors.newPassword}
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label col-4 required">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  {errors.confirmPassword && (
                    <div className="text-danger">
                      {errors.confirmPassword}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="col-3 justify-content-center">
                      <button type="submit" className="btn btn-primary d-grid w-30" >
                        Reset Password
                      </button>
                    </div>
                    <div className=" ">
                      <a href="/login"
                        className="px-0 fs-14 border-none"
                        style={{ backgroundColor: 'transparent' }}
                      >
                        Go back to login
                      </a>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 justify-content-center"></div>
                </div>
              </form>
            </>
          </div>
        </div>
      </div>
    </div>
  );
}
